import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Helper to ensure dates are treated as UTC if missing timezone
 */
export const parseAsUTC = (dateStr: string | Date | number | null | undefined) => {
  if (!dateStr) return new Date();
  if (dateStr instanceof Date) return dateStr;
  const s = String(dateStr);
  if (s.endsWith('Z') || s.includes('+')) return new Date(s);
  if (s.includes('T')) return new Date(s + 'Z');
  return new Date(s);
};
